export const ValidatorPattern = {
  Email_Validator:
    '[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z]{2,}',
  Multi_Email_Validator: String.raw`[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(\s*,\s*[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,})*`,
  PhoneValidationWith10NumbersHyphen: '^[0-9-]+$',
  OnlyAlpha_Validator: '^[a-zA-Z]+(?: [a-zA-Z]+)*$',
  SevenDigitTwoDecimal: /^\d{0,7}\.?\d{0,2}$/g,
  SeventeenDigitTwoDecimal: /^\d{0,17}\.?\d{0,2}$/g,
  TenDigitTwoDecimal: /^-?\d{0,10}\.?\d{0,2}$/g,
  TwoDigitTwoDecimal: /^\d{0,2}\.?\d{0,2}$/g,
  FourAlphabetsWithNumbers: `^[A-Za-z]{0,4}[0-9]{0,6}$`,
  TwoAlphabetsWithNumbers: `^[A-Za-z]{0,2}[0-9]{0,4}$`,
  DateMMDDYYYYFormat: 'MM/dd/yyyy HH:mm:ss zzz',
  IST: 'IST',
  ThreeNumbersHyphenEightNumbers: /(?<=^\d{3})(?=\d)/g,
  ThreeAlphabetsWithNumbers: '^[A-Za-z0-9]{3}[0-9]{4,6}$',
  FlightNumberAlphaNumericPrefixDigits: /^[A-Za-z0-9]{2,3}\d{3,6}$/,
  StartPositionSpaceNotAllowed: /^\s+/,
  NANPPhoneValidation:
    '^(?:[2-9][0-9]{2}-[2-9][0-9]{2}-[0-9]{4}|[2-9][0-9]{2}[2-9][0-9]{2}[0-9]{4})$',
  flightValidation: '^[A-Za-z]{2}[0-9]{1,4}$',
  emailUserValidator:
    /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/,
  alphaNumerics: /^[a-zA-Z0-9]*$/,
  NineDigitThreeDecimal: /^\d{0,9}\.?\d{0,3}$/g,
  FourDigitThreeDecimal: /^\d{0,4}\.?\d{0,3}$/g,
  OneHundredTwentySixCharTwoDecimal: /^\d{0,123}\.?\d{0,2}$/g,
  numericOnlyPattern: '^[0-9]{1,15}$',
  NonDigit: String.raw`\D`,
  ValidAlphabetsOnly: '[^ABC]',
  /**
   * Has minimum 8 characters and maximum 64 characters in length.
   * Adjust it by modifying {8,64}
   *
   * At least one uppercase English letter.
   * You can remove this condition by removing (?=.*?[A-Z])
   *
   * At least one lowercase English letter.
   * You can remove this condition by removing (?=.*?[a-z])
   *
   * At least one digit.
   * You can remove this condition by removing (?=.*?[0-9])
   *
   * At least one special character, You can remove this condition by removing (?=.*?[#?!@$%^&*-])
   */
  passwordPattern:
    '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-~]).{8,64}$',
  onlyNumbers: /^\d+$/,
  TwoDecimalPlaces: String.raw`^\d+(\.\d{1,2})?$`,
  AlphaNumericWithHyphenAmpersandParenthesesSpace: /[^a-zA-Z0-9 \-&()]/g,
};
